import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../models';

export interface IAirportService {
  getAirportList(search: string): Observable<Array<models.Airport>>;
}

export const SERVICE_TOKEN = new InjectionToken('Shared.IAirportService');
